import styled from 'styled-components'

export const Wrapper = styled.div`
  padding: 0 15px;
  max-width: 950px;
  margin: 0 auto;

  > p {
    text-align: center;
    margin: 5px 0;
    padding: 0 30px;
  }

  > h2 {
    ${props => props.theme.css.heading1};
    font-weight: ${props => props.theme.font.alt.bold};
    margin-bottom: 10px;
    text-align: center;
  }

  .container {
    margin: 50px auto 5vw;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    grid-gap: 20px;
  }
`

export const Box = styled.div<{ textAlignment: string }>`
  text-align: ${props => props.textAlignment};
  padding: 30px;
  margin: auto;
  background: no-repeat center / contain;
  min-height: 250px;
  max-width: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  p {
    font-family: ${props => props.theme.font.alt.family};
    font-size: 16px;
    margin: 18px 0 0;
    line-height: 1.5;
  }

  em {
    display: block;
    font-size: 12px;
  }

  .icon {
    width: 30px;
    height: 30px;
    filter: brightness(100);
    margin: 0 auto;
  }

  .btn {
    margin: 10px auto 0;
  }
`
